import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Search, Button, Loading } from 'carbon-components-react';

import { Container, ContentContainer } from '../../components/Wrapper/Wrapper';

import TileHeader from '../../components/TileHeader/TileHeader';
import ConfirmModal from '../../components/Modal/ConfirmModal';
import ConditionsGrid from './ConditionsGrid';
import ConditionDetailModal from './ConditionDetailModal';

import { getAllConditions, deleteCondition } from '../../api/conditions';

import { toaster } from '../../helpers/toaster';
import usePollReport from '../../hooks/usePollReport';
import { triggerReport } from '../../api/studyListApi';

const Conditions = () => {
	// loading is for initial component preloading
	const [loading, setLoading] = useState(false);

  const [conditionList, setConditionList] = useState([]);
  const [search, setSearch] = useState("");
  const [searchGrid, setSearchGrid] = useState("");
  const [openConditionModal, setConditionModalStatus] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [deleteItemName, setDeleteItemName] = useState("");
  const [refreshData, setRefreshData] = useState(false);
  const [sort, setSort] = useState("")

  // modal params
  const [modalConditionName, setModalConditionName] = useState("");
  const [modalSynonyms, setModalSynonyms] = useState([]);
  const [modalRootCondition, setModalRootCondition] = useState([]);
  const [modalStudies, setModalStudies] = useState([]);
  const [detailModalMode, setDetailModalMode] = useState("");
  const [conditionId, setConditionId] = useState(null);
  const [description, setDescription] = useState("")
  const [imageData, setImageData] = useState({})
  const [additionalInfo, setAdditionalInfo] = useState({})

  const onlyAttachment = localStorage.getItem('only_attachment')

  const { startPolling, status: reportStatus } = usePollReport({
    onSuccess: () => { toaster('Conditions report downloaded successfully', 'success'); },
    onError: () => toaster('Failed to generate report. Please try again.', 'error'),
  });

  const [openReportModal, setOpenReportModal] = useState(false);

  const handleGenerateReport = () => {
    setOpenReportModal(false);
    triggerReport('conditions')
      .then(({ task_id }) => {
        toaster('Generating conditions report...', 'info');
        startPolling(task_id);
      })
      .catch(() => toaster('Failed to start report generation.', 'error'));
  };


  const addConditionBtnStyle = {
    padding: "11px 18px",
    height: "auto",
    minHeight: "unset",
    borderRadius: "10px",
    fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
    fontWeight: 700,
    fontSize: "13.5px",
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setSearchGrid(search);
    }, 1000)
    // if this effect run again, because `value` changed, we remove the previous timeout
    return () => clearTimeout(timeout)
  }, [search]);
  // useEffect(() => {
  //   getConditions();
  // }, []);

  // const getConditions = () => {
  //   setLoading(true);
  //   getAllConditions().then(items => {
  //     items = items.map(item => ({
  //       ...item,
  //       synonymsText: (item.synonyms || []).slice(0, 5).join(", "),
  //       studiesText: (item.studies || []).map(ele => ele.org_study_id).slice(0, 2).join(", "),
  //     }));
  //     setConditionList(items);
  //     setLoading(false);
  //   });
  // };

  const addNewCondition = () => {
    setDetailModalMode("create");
    setModalConditionName("");
    setModalSynonyms([]);
    setModalStudies([]);
    setModalRootCondition([]);

    setConditionModalStatus(true);
  };

  const conditionRowClicked = (data) => {
    setDetailModalMode("update");
    setConditionId(data.id);
    setModalConditionName(data.name || "");
    setDescription(data?.additional_info?.description)
    setImageData(data?.image_info)
    setAdditionalInfo(data?.additional_info)

    let synIds = [];
    let syns = [];
    if (data.synonyms && data.synonyms.length) {
      syns = data.synonyms.map(syn=> ({label: syn, value: syn}))
    }
    setModalSynonyms(syns);

    let studyIds = [];
    if (data.studies && data.studies.length) {
      studyIds = data.studies.map(study => study.id);
    }
    setModalStudies(studyIds);

    let rootCond = [];
    if (data.root_condition && Object.keys(data.root_condition).length) {
      rootCond = data.root_condition?.id
    }
    setModalRootCondition(rootCond);

    setConditionModalStatus(true);
  };

  const showDeleteConfirm = (itemId, itemName) => {
    setOpenDeleteModal(true);
    setDeleteItemId(itemId);
    setDeleteItemName(itemName || "");
  };

  const confirmDelete = () => {
    setOpenDeleteModal(false);
    setLoading(true);
    deleteCondition(deleteItemId).then(res => {
      toaster("Condition deleted successfully", "success")
      setLoading(false);
      setRefreshData(true);
      // getConditions();
    });
  };
  const refreshTriggered = () => {
    setRefreshData(true);
  }

  return (
    <Container>
      <ContentContainer>

        <TileHeader
            title="Conditions"
            // subtitle="A list of all conditions. To add a condition click the ‘Add Condition’ button. Edit condition values directly in the table."
            size="lg"


        />
        {
					loading ?
					<Loading

          />
					:
					<></>
				}

        <ConditionsContent>
          <ActionBar>
            <div style={{ width: "300px" }}>
              <Search
                size="sm"
                value={search}
                labelText="search"
                onChange={e => setSearch(e.target.value)}
                placeHolderText="Search using any data value"/>
            </div>

            <ButtonGroup>
              <Button
                kind="secondary"
                onClick={() => setOpenReportModal(true)}
                disabled={reportStatus === 'polling'}
                style={addConditionBtnStyle}
              >{reportStatus === 'polling' ? 'Generating...' : 'Generate Report'}</Button>
              <Button
                kind="primary"
                onClick={() => addNewCondition()}
                style={addConditionBtnStyle}
                disabled={onlyAttachment === "true"}
              >Add Condition</Button>
            </ButtonGroup>
          </ActionBar>

          <ConditionsGrid
            conditionList={conditionList}
            search={searchGrid}
            onRowClicked={conditionRowClicked}
            onDeleteClicked={showDeleteConfirm}
            setRefresh={setRefreshData}
            refresh={refreshData}
            sort={sort}
            setSort={setSort}
          />
        </ConditionsContent>

        <ConditionDetailModal
          mode={detailModalMode}
          conditionId={conditionId}
          open={openConditionModal}
          name={modalConditionName}
          synonyms={modalSynonyms}
          parentCondition={modalRootCondition}
          studies={modalStudies}
          refreshConditions={refreshTriggered}
          onClose={() => setConditionModalStatus(false)}
          refreshData={refreshData}
          description={description}
          imageData={imageData}
          additionalInfo={additionalInfo}
        />

        <ConfirmModal
          title="Confirmation"
          content={`Are you sure you want to delete the condition "${deleteItemName}"?`}
          open={openDeleteModal}
          onClose={() => setOpenDeleteModal(false)}
          onConfirm={() => confirmDelete()}
        />
        <ConfirmModal
          title="Generate Report"
          content="Do you want to generate the report? This may take awhile. Navigating away from this page will stop the report generation."
          open={openReportModal}
          onClose={() => setOpenReportModal(false)}
          onConfirm={handleGenerateReport}
        />

      </ContentContainer>
    </Container>
  );
};

export default Conditions;

const ConditionsContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 22px 24px;
  background-color: #fff;
  border: 1px solid #e7eaf0;
  border-radius: 14px;
  box-shadow: 0 1px 3px rgba(0,0,0,.04);
`

const ActionBar = styled.div`
  width: 100%;
  height: fit-content;
  background-color: #fff;
  margin-bottom: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;
`

const ConditionsFooter = styled.div`
  width: 100%;
  height: fit-content;
  background-color: #fff;
  padding: 0px 20px 20px 20px;
  margin-bottom: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
`
